export default "__VITE_ASSET__BtejNov2__"